import { getAllowedOrderTicketCountForAreaCategory } from './get-allowed-order-ticket-count-for-area-category';
import { getOrderTicketCountForAreaCategory } from './get-order-ticket-count-for-area-category';
export const getRemainingOrderTicketCountForAreaCategory = (showtimeId, areaCategoryId) => {
    const maximumCount = getAllowedOrderTicketCountForAreaCategory(showtimeId, areaCategoryId);
    const currentCount = getOrderTicketCountForAreaCategory(showtimeId, areaCategoryId);
    return maximumCount - currentCount;
};
